import http from '@/core/http';

const system = {
  actions: {
    // 版本列表
    SystemVersionList (ctx, payload) {
      return http.req_post('/admin/action/wxappversion', { ...payload });
    },
    // 添加/修改版本
    SystemVersionAdd (ctx, payload) {
      return http.req_post('/admin/action/savewxappver', { ...payload });
    },
    // 版本信息
    SystemVersionInfo (ctx, payload) {
      return http.req_post('/admin/action/wxappverinfo', { ...payload });
    },
    // 版本发布
    SystemVersionPublish (ctx, payload) {
      return http.req_post('/admin/action/wxappverpub', { ...payload });
    },
    // 版本删除
    SystemVersionDelete (ctx, payload) {
      return http.req_post('/admin/action/wxappverdel', { ...payload });
    },
    // 主题列表
    SystemThemeList (ctx, payload) {
      return http.req_post('/admin/action/themelist', { ...payload });
    },
    // 添加/修改主题
    SystemThemeAdd (ctx, payload) {
      return http.req_post('/admin/action/savetheme', { ...payload });
    },
    // 小程序页面模板
    MiniappPageTemplates (ctx, payload) {
      return http.req_get('/admin/template/list', { ...payload });
    },
    // 小程序页面模板详情
    MiniappPageTemplateInfo (ctx, payload) {
      return http.req_post('/admin/template/info', { ...payload });
    },
    // 添加/编辑小程序页面模板
    MiniappPageTemplateAdd (ctx, payload) {
      return http.req_post('/admin/template/save', { ...payload });
    },
    // 小程序页面模板状态设置
    MiniappPageTemplateStatusSet (ctx, payload) {
      return http.req_post('/admin/template/savestatus', { ...payload });
    },
    // 获取模板详情
    GetPageTemplatesData(ctx, payload) {
      return http.req_post('/admin/template/info', { ...payload });
    },
    // 修改模板内容
    SavePageTemplatesData(ctx, payload) {
      return http.req_post('/admin/template/savecontent', { ...payload });
    },
    // 获取门店数据
    GetPageInfoData(ctx, payload) {
      return http.req_post('/admin/action/getstoreparam', { ...payload });
    },
    // 获取首页菜单配置
    GetMiniHomeMenus (ctx, payload) {
      return http.req_get('/admin/action/gethomecate', { ...payload });
    },
    // 获取小程序门店列表数据
    GetPageComponentStoreList(ctx, payload) {
      return http.req_get('/admin/action/getmerstorelist', { ...payload });
    },
  },
};

export default system;